interface Config {
    stateSecret: string;
    environment: string;
    tenant: string;
    apiUrl: string;
    naturimalB2BUrl: string;
    appInsightsConnectionString: string | undefined;
    sessionExpirationHours: number;
    carouselSpinSeconds: number;
}

const config: Config = {
    stateSecret: import.meta.env.VITE_STATE_SECRET || '',
    environment: import.meta.env.VITE_REACT_ENV || '',
    tenant: import.meta.env.VITE_TENANT || '',
    apiUrl: import.meta.env.VITE_API_URL || '',
    naturimalB2BUrl: import.meta.env.VITE_NATURIMAL_B2B_URL || '',
    appInsightsConnectionString: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING && import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING !== 'secret'? import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING : undefined,
    sessionExpirationHours: import.meta.env.VITE_SESSION_EXPIRATION_HOURS,
    carouselSpinSeconds: Number(import.meta.env.VITE_CAROUSEL_SPIN_SECONDS) || 10,
};

export default config;